import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { Button, Image } from '@heroui/react';

import { ORTHO_ASSETS } from './ortho-assets';

export function Picker({ data, sendAnswer, answerHistory }) {
  const { t } = useTranslation('survey');

  const initAnswer = answerHistory || 0;
  const [answer, setAnswer] = useState(initAnswer);

  useEffect(() => {
    sendAnswer(initAnswer);
  }, []);

  const down = () => {
    if (answer < data.length - 1) {
      setAnswer(answer + 1);
      sendAnswer(answer + 1);
    }
  };

  const up = () => {
    if (answer >= 1) {
      setAnswer(answer - 1);
      sendAnswer(answer - 1);
    }
  };

  const image = useMemo(() => {
    if (answer === undefined) {
      return '';
    }

    const path = data[answer].text;
    const fileName = path.substring(path.lastIndexOf('/') + 1);
    const img = ORTHO_ASSETS[fileName] || '';

    return img;
  }, [answer]);

  const alt = useMemo(() => {
    if (answer === undefined) {
      return '';
    }

    const fileName = data[answer].text;
    const degrees = fileName.match(/\d+/g).map(Number);

    return t('picker.selected_hint', { answer: degrees });
  }, [answer]);

  return (
    <div>
      <div className="flex justify-center">
        <Image alt={alt} className="max-w-sm" src={image} disableSkeleton />
      </div>
      <div className="flex justify-center gap-12 my-4">
        <Button
          aria-label={t('picker.button.down')}
          color="primary"
          isIconOnly
          onPress={() => down()}
          className="w-[64px] h-[64px]"
          variant="faded"
        >
          <Icon icon="mdi:arrow-down" className="text-5xl" />
        </Button>
        <Button
          aria-label={t('picker.button.up')}
          color="primary"
          isIconOnly
          onPress={() => up()}
          className="w-[64px] h-[64px]"
          variant="faded"
        >
          <Icon icon="mdi:arrow-up" className="text-5xl" />
        </Button>
      </div>
    </div>
  );
}
